// extracted by mini-css-extract-plugin
export var buttons = "_ba-0";
export var buttonsActive = "_ba-h";
export var cancelConfirm = "_ba-1";
export var closeButton = "_ba-2";
export var column = "_ba-3";
export var container = "_ba-4";
export var detailHeader = "_ba-6";
export var detailTitle = "_ba-7";
export var detailsContent = "_ba-5";
export var header = "_ba-8";
export var headerWithClose = "_ba-9";
export var icon = "_ba-a";
export var infoIcon = "_ba-c";
export var informationContainer = "_ba-b";
export var sideDrawer = "_ba-d";
export var sideDrawerOpen = "_ba-e";
export var stickyFooter = "_ba-f";
export var typeOption = "_ba-g";